import addDocumentFailure from './addDocument/failure';
import addDocumentRequest from './addDocument/request';
import addDocumentSuccess from './addDocument/success';
import addNoteFailure from './addNote/failure';
import addNoteRequest from './addNote/request';
import addNoteSuccess from './addNote/success';
import addWorkerFailure from './addWorker/failure';
import addWorkerRequest from './addWorker/request';
import addWorkerSuccess from './addWorker/success';
import archiveThreadMessageFailure from './archiveThreadMessage/failure';
import archiveThreadMessageRequest from './archiveThreadMessage/request';
import archiveThreadMessageSuccess from './archiveThreadMessage/success';
import createThreadFailure from './createThread/failure';
import createThreadRequest from './createThread/request';
import createThreadSuccess from './createThread/success';
import createThreadMessageFailure from './createThreadMessage/failure';
import createThreadMessageRequest from './createThreadMessage/request';
import createThreadMessageSuccess from './createThreadMessage/success';
import deleteDocumentFailure from './deleteDocument/failure';
import deleteDocumentRequest from './deleteDocument/request';
import deleteDocumentSuccess from './deleteDocument/success';
import editFailure from './edit/failure';
import editRequest from './edit/request';
import editSuccess from './edit/success';
import getAllFailure from './getAll/failure';
import getAllRequest from './getAll/request';
import getAllSuccessWithData from './getAll/successWithData';
import getAllSuccessWithoutData from './getAll/successWithoutData';
import getAllThreadsFailure from './getAllThreads/failure';
import getAllThreadsRequest from './getAllThreads/request';
import getAllThreadsSuccessWithData from './getAllThreads/successWithData';
import getAllThreadsSuccessWithoutData from './getAllThreads/successWithoutData';
import getDetailsFailure from './getDetails/failure';
import getDetailsRequest from './getDetails/request';
import getDetailsSuccess from './getDetails/success';
import getDocumentsFailure from './getDocuments/failure';
import getDocumentsRequest from './getDocuments/request';
import getDocumentsSuccess from './getDocuments/success';
import getSearchedInterventionFailure from './getSearched/failure';
import getSearchedInterventionRequest from './getSearched/request';
import getSearchedInterventionSuccessWithData from './getSearched/successWithData';
import getSearchedInterventionSuccessWithoutData from './getSearched/successWithoutData';
import getStatusDateChangedFailure from './getStatusDateChanged/failure';
import getStatusDateChangedRequest from './getStatusDateChanged/request';
import getStatusDateChangedSuccess from './getStatusDateChanged/success';
import markThreadMessageAsOpenFailure from './markThreadMessageAsOpen/failure';
import markThreadMessageAsOpenRequest from './markThreadMessageAsOpen/request';
import markThreadMessageAsOpenSuccess from './markThreadMessageAsOpen/success';
import removeWorkerFailure from './removeWorker/failure';
import removeWorkerRequest from './removeWorker/request';
import removeWorkerSuccess from './removeWorker/success';
import setClearDetails from './set/clearDetails';
import setClearInterventionList from './set/clearInterventionList';
import setFilters from './set/filters';
import setTimeline from './set/timeline';
import updateNoteFailure from './updateNote/failure';
import updateNoteRequest from './updateNote/request';
import updateNoteSuccess from './updateNote/success';

const reducers = {
  addDocumentFailure,
  addDocumentRequest,
  addDocumentSuccess,
  addNoteFailure,
  addNoteRequest,
  addNoteSuccess,
  addWorkerFailure,
  addWorkerRequest,
  addWorkerSuccess,
  archiveThreadMessageFailure,
  archiveThreadMessageRequest,
  archiveThreadMessageSuccess,
  createThreadFailure,
  createThreadRequest,
  createThreadSuccess,
  createThreadMessageFailure,
  createThreadMessageRequest,
  createThreadMessageSuccess,
  deleteDocumentFailure,
  deleteDocumentRequest,
  deleteDocumentSuccess,
  editFailure,
  editRequest,
  editSuccess,
  getAllFailure,
  getAllRequest,
  getAllSuccessWithData,
  getAllSuccessWithoutData,
  getAllThreadsFailure,
  getAllThreadsRequest,
  getAllThreadsSuccessWithData,
  getAllThreadsSuccessWithoutData,
  getDetailsFailure,
  getDetailsRequest,
  getDetailsSuccess,
  getDocumentsFailure,
  getDocumentsRequest,
  getDocumentsSuccess,
  getSearchedInterventionFailure,
  getSearchedInterventionRequest,
  getSearchedInterventionSuccessWithData,
  getSearchedInterventionSuccessWithoutData,
  getStatusDateChangedFailure,
  getStatusDateChangedRequest,
  getStatusDateChangedSuccess,
  markThreadMessageAsOpenFailure,
  markThreadMessageAsOpenSuccess,
  markThreadMessageAsOpenRequest,
  removeWorkerFailure,
  removeWorkerSuccess,
  removeWorkerRequest,
  setClearDetails,
  setClearInterventionList,
  setTimeline,
  setFilters,
  updateNoteFailure,
  updateNoteRequest,
  updateNoteSuccess,
};

export default reducers;
